<script setup>
import { useAttrs, useId } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
const uid = useId();
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient :id="`pb-${uid}`" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="#ff13f0" />
        <stop offset="50%" stop-color="#C85CA9" />
        <stop offset="100%" stop-color="#C700E3" />
      </linearGradient>
    </defs>
    <g transform="translate(80,60) scale(14,14)">
      <path
        d="M8.405 6.786C3.765 6.786 0 10.546 0 15.191V32.162L2.514 32.162C7.158 32.162 10.918 28.396 10.918 23.757V6.786H8.405ZM8.895 24.189C8.895 27.468 6.236 30.133 2.951 30.133L2.028 30.133V14.754C2.028 11.474 4.688 8.809 7.973 8.809H8.895V24.189Z"
        :fill="`url(#pb-${uid})`"
        fill-rule="nonzero"
      />
      <path
        d="M13.642 6.819H17.844C21.583 6.819 24.614 9.85 24.614 13.589C24.614 17.327 21.583 20.359 17.844 20.359H13.642V6.819Z"
        :fill="`url(#pb-${uid})`"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>
